import { create } from "zustand";
import { persist } from "zustand/middleware";

interface IPartnerStore {
  sessionExpiredRedirectUrl: string | null;
  partnerName: string | null;
  setPartnerInfo: (info: { sessionExpiredRedirectUrl?: string; name?: string }) => void;
  clearPartnerInfo: () => void;
}

/**
 * Store to persist partner info that's needed even after session expires.
 * This is separate from useSessionStore because we need this data
 * even when the session is in an error state (e.g., LINK_NOT_FOUND).
 */
export const usePartnerStore = create<IPartnerStore>()(
  persist(
    (set) => ({
      sessionExpiredRedirectUrl: null,
      partnerName: null,
      setPartnerInfo: (info) => {
        set({
          sessionExpiredRedirectUrl: info.sessionExpiredRedirectUrl || null,
          partnerName: info.name || null,
        });
      },
      clearPartnerInfo: () => {
        set({
          sessionExpiredRedirectUrl: null,
          partnerName: null,
        });
      },
    }),
    {
      name: "raas-widgets-screenbook-partner",
    }
  )
);
